(() => {
const bioDescription=document.querySelector('.bio-description');
const bioToggle=bioDescription?.querySelector('.bio-toggle');
if(bioToggle){
  bioDescription.dataset.expanded='false';
  bioToggle.hidden=false;
  bioToggle.addEventListener('click',()=>{
    const expanded=bioToggle.getAttribute('aria-expanded')!=='true';
    bioToggle.setAttribute('aria-expanded',String(expanded));
    bioDescription.dataset.expanded=String(expanded);
    bioToggle.textContent=expanded?'menos':'mais';
  });
}
// URLs supplied by the user; keep marketplace selection and attribution intact.
const destinations = {
  mercadoP: 'https://www.mercadolivre.com.br/brinquedo-silicona-p-resistente-calor-seguro-comest-bollball/up/MLBU4814133767?pdp_filters=seller_id%3A2537288374#polycard_client%3Drecommendations_recoview-selleritems-eshops%26reco_backend%3Dsame-seller-odin%26reco_client%3Drecoview-selleritems-eshops%26reco_item_pos%3D1%26reco_backend_type%3Dlow_level%26reco_id%3D1476e8fd-0ca0-4925-bd0f-d0c50b6a9bf0%26wid%3DMLB7455444624%26sid%3Drecos%26tracking_id%3Dfcf03273b8aaa3e7f9320d89d656e285%26source%3Deshops%26seller_id%3D2537288374%26category_id%3DMLB418060',
  mercadoG: 'https://www.mercadolivre.com.br/brinquedo-silicona-g-resistente-calor-seguro-comest-bollball/up/MLBU4870894714?product_trigger_id=MLBU4870900306&pdp_filters=seller_id%3A2537288374&applied_product_filters=MLBU4870900308&picker=true&quantity=1',
  mercadoKit: 'https://www.mercadolivre.com.br/2pcspg-conjunto-silicona-bollball-resistentes-calor-seguros/up/MLBU4872713708?product_trigger_id=MLBU4872713710&pdp_filters=seller_id%3A2537288374&applied_product_filters=MLBU4872713710&picker=true&quantity=1',
  tiktok1: 'https://shop.tiktok.com/br/pdp/1736101166078461111?_t=ZS-99zc4LTC0Hc',
  tiktok2: 'https://shop.tiktok.com/br/pdp/1736482103721624759?_t=ZS-99zc6aLqHH3',
  whatsapp: 'https://wa.me/5511912294680', retail: 'https://wa.me/5511912294680', creators: 'https://wa.me/5511912294680',
};
const labels={whatsapp:'WhatsApp',retail:'Parcerias para revenda',creators:'Parcerias com criadores'};
const dialog=document.querySelector('dialog');
for(const element of document.querySelectorAll('[data-destination]')){
  const key=element.dataset.destination;
  let valid=false;
  try{valid=new URL(destinations[key]).protocol==='https:';}catch{}
  if(valid)element.href=destinations[key];
  else element.addEventListener('click',()=>{
    stopRotation();
    document.querySelector('#preview-title').textContent=labels[key];
    document.querySelector('#preview-description').textContent=key==='whatsapp'
      ? 'Prévia: o destino e a disponibilidade do atendimento ainda precisam ser confirmados.'
      : 'Prévia: o link deste destino ainda precisa ser configurado. Nenhuma mensagem será enviada.';
    dialog.showModal();
  });
}
const carousel=document.querySelector('.carousel');
const cards=[...document.querySelectorAll('.product-card')];
const dots=[...document.querySelectorAll('[data-slide]')];
const stage=document.querySelector('.stage');
// Stage height follows the centered card; 44 = card top offset 16 + 28 breathing room (shadow trimmed).
function syncStage(){
  const details=cards.map(card=>card.querySelector('.card-detail'));
  details.forEach(detail=>{detail.style.minHeight='0';});
  const height=Math.max(...details.map(detail=>detail.offsetHeight));
  details.forEach(detail=>{detail.style.minHeight=height+'px';});
  stage.style.height=(cards[index].offsetHeight+44)+'px';
}
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
let index=0,timer=null,rotating=!reducedMotion.matches;
function render(announce=false){
  cards.forEach((card,i)=>{
    card.classList.remove('left','right','center');
    card.classList.add(i===index?'center':i===(index+1)%3?'right':'left');
    const detail=card.querySelector('.card-detail');
    detail.inert=i!==index;detail.setAttribute('aria-hidden',String(i!==index));
    card.querySelector('.select-card').setAttribute('aria-pressed',String(i===index));
  });
  dots.forEach((dot,i)=>i===index?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));
  syncStage();
  if(announce)document.querySelector('#slide-status').textContent=`Produto ${index+1} de 3 selecionado.`;
}
function select(next,user=true){if(user)stopRotation();index=(next+3)%3;render(user);}
function schedule(){clearInterval(timer);timer=null;if(rotating&&!document.hidden&&!carousel.matches(':hover'))timer=setInterval(()=>select(index+1,false),5500);}
function stopRotation(){rotating=false;clearInterval(timer);timer=null;}
cards.forEach((card,i)=>card.querySelector('.select-card').addEventListener('click',()=>select(i)));
dots.forEach(dot=>dot.addEventListener('click',()=>select(Number(dot.dataset.slide))));
document.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>select(index+Number(button.dataset.step))));
carousel.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();select(index+(event.key==='ArrowRight'?1:-1));}});
carousel.addEventListener('focusin',stopRotation);
carousel.addEventListener('mouseenter',()=>clearInterval(timer));
carousel.addEventListener('mouseleave',schedule);
document.addEventListener('visibilitychange',schedule);
reducedMotion.addEventListener('change',()=>{if(reducedMotion.matches)stopRotation();});
let start=null;
carousel.addEventListener('touchstart',event=>{start={x:event.touches[0].clientX,y:event.touches[0].clientY};stopRotation();},{passive:true});
carousel.addEventListener('touchend',event=>{if(!start)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))select(index+(dx<0?1:-1));},{passive:true});
carousel.addEventListener('touchcancel',()=>{start=null;});
render();schedule();
addEventListener('resize',syncStage);
document.fonts.ready.then(syncStage);
if('ResizeObserver' in window){const cardObserver=new ResizeObserver(syncStage);cards.forEach(card=>cardObserver.observe(card));}



// Share the actual page URL, without preview versions or in-page anchors.
const shareButton=document.querySelector('.share-button');
const shareStatus=document.querySelector('.share-status');
function showShareStatus(message){shareStatus.textContent=message;shareStatus.hidden=false;}
shareButton.addEventListener('click',async()=>{
  const url=new URL(location.href);
  url.search='';url.hash='';
  if(url.protocol==='file:'||['localhost','127.0.0.1','[::1]'].includes(url.hostname)){
    showShareStatus('Esta prévia é local. O compartilhamento ficará disponível quando a página for publicada.');
    return;
  }
  shareButton.disabled=true;
  shareStatus.hidden=true;
  try{
    if(navigator.share){
      try{await navigator.share({title:'bollball',text:'Conheça a bollball.',url:url.href});return;}
      catch(error){if(error.name==='AbortError')return;}
    }
    try{
      await navigator.clipboard.writeText(url.href);
      showShareStatus('Link copiado!');
    }catch{
      showShareStatus('Copie este link para compartilhar: '+url.href);
    }
  }finally{shareButton.disabled=false;}
});

})();
